function useCache(Table){
    return Table;
}

export default useCache;

useCache.displayName = 'useCache';
useCache.dependence = [];
useCache.hooks = function(){
    return {
        setCache: (path, value) => {
            if(value){
                if (typeof value === 'object') {
                    value = JSON.parse(JSON.stringify(value));
                } 
                this.set(['_cache'].concat(path), value);
            } else {
                this.set(['_cache'].concat(path), undefined);
            }
        },
        getCache: (path, { strict } = {}) => {
            let rawValue = this.get(['_cache'].concat(path));
            if ([null, undefined].includes(rawValue) && strict) {
                return rawValue;
            } else {
                return JSON.parse(JSON.stringify(this.get(['_cache'].concat(path)) || {}));
            }
        },
    };
};
useCache.propsGenerator = function(props){
    return props;
};
